import Axios from "axios";
import { axiosClient } from "./axiosClient";

import Cookies from "js-cookie";
// cons
//localhost:62610/'
export const API_DOMAIN = "https://api-customer-netco.vps.vn";
// export const API_DOMAIN = "http://localhost:62610";
//const API_DOMAIN = 'http://api-test-customer.netco.com.vn'

const VERSION_END_POINT = "/api";
const VERSION_END_POINT_APP = "/api/ApiMain";
const ENV_X_API_KEY = process.env.REACT_APP_X_API_KEY || "";

export const GOOGLE_LOGIN_CLIENTID =
  "418580183625-h3psg5ke3ri923qg5kuos64jmr0j2fuj.apps.googleusercontent.com";
export const FACEBOOK_LOGIN_APPID = "836612320191788";

// Helper function để kiểm tra môi trường dựa trên URL
export const isDevelopment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

export const X_API_KEY = isDevelopment() ? ENV_X_API_KEY : "";


export const TOKEN_DEVICE = "website";
export const API_END_POINT = API_DOMAIN + VERSION_END_POINT;
export const API_END_POINT_APP = API_DOMAIN + VERSION_END_POINT_APP;

export const GOOGLE_MAP_API_KEY = "AIzaSyC3FcrqPxQz1sgE9IcEqJNalRMcB21V9nw"; //'AIzaSyBuzp_wR2Iawrq2Nc4RAapnH9YtyunC2KA'//'AIzaSyAl8WZfFte7tdA-GgRC281-c8ufJdEGtd4'; //'AIzaSyBdzbUGthJC0EQAmUsAXgh4J0OUN9uVh4g' //
export const GOOGLE_MAP_ZOOM = 5;
export const GOOGLE_MAP_CENTER = { lat: 14.775869, lng: 106.688661 };

export const EXPRIRES_ACCESS_TOKEN = 30; //tính bằng phút
export const EXPRIRES_REFRESH_TOKEN = 1; // tính bằng ngày
export const EXPRIRES__TOKEN = 25; // tính bằng phút

export const api = Axios.create({
  baseURL: API_END_POINT,
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": X_API_KEY,
    Accept: "application/json",
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};


//#region  Xử lý trường hợp token hết hạn
api.interceptors.response.use(
  (response) => response, //trường hợp trả về statusCode 200 => token còn hạn
  async (error) => {
    //trường hợp trả về statusCode 4xx 5xx
    const originalRequest = error.config;

    // ✅ CHỈ XỬ LÝ 401 (Unauthorized - Token hết hạn)
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;
      try {
        if (!sessionStorage.getItem("_e_d_r_f")) {
          window.location.href = "/";
          processQueue(error, null);
          return Promise.reject(error);
        }
        //refresh lại token mới nếu như Cookies.get("refreshToken") còn hạn sử dụng
        const { data } = await axiosClient.API_Token(
          `grant_type=refresh_token&client_id=${Cookies.get(
            "client_id"
          )}&refresh_token=${sessionStorage.getItem("_e_d_r_f")}`
        );
        const inFifteenMinutes = new Date(
          new Date().getTime() + EXPRIRES_ACCESS_TOKEN * 60 * 1000
        );
        Cookies.set("accessToken", data.access_token, {
          expires: inFifteenMinutes,
        });
        const expiryTime =
          new Date().getTime() + EXPRIRES_ACCESS_TOKEN * 60 * 1000; // Thời gian hết hạn tính bằng milliseconds
        localStorage.setItem("tokenExpiryTime", expiryTime);
        api.defaults.headers.common["Authorization"] =
          "Bearer " + data.access_token;
        originalRequest.headers["Authorization"] =
          "Bearer " + data.access_token;
        processQueue(null, data.access_token);
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }
    
    // ✅ CÁC LỖI KHÁC (403, 400, 500...) => TRẢ VỀ RESPONSE, KHÔNG REJECT
    // Saga sẽ xử lý dựa vào response.data với resultCode
    if (error.response) {
      // Có response từ server => trả về để Saga xử lý
      return Promise.resolve(error.response);
    }
    
    // ✅ LỖI NETWORK (không có response) => VẪN REJECT
    return Promise.reject(error);
  }
);

//#region Interceptor để thêm token vào header của mỗi yêu cầu
api.interceptors.request.use(
  async (config) => {
    if (!config.headers) {
      config.headers = {};
    }

    // Ensure X-API-Key is set
    config.headers["X-API-Key"] = X_API_KEY;

    // Add Authorization token if available
    const token = Cookies.get("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      console.warn("No access token found in cookies");
    }

    // Add default headers
    config.headers["Content-Type"] =
      config.headers["Content-Type"] || "application/json";
    config.headers["Accept"] = "application/json";

    return config;
  },
  function (error) {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

export default api;

export const setToken = (token) => {
  if (token) {
    // Set token in headers
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    // Set token in cookies with proper expiration
    const expirationDate = new Date(
      new Date().getTime() + EXPRIRES_ACCESS_TOKEN * 60 * 1000
    );
    Cookies.set("accessToken", token, {
      expires: expirationDate,
      path: "/",
      secure: true,
      sameSite: "Strict",
    });

    // Store expiry time
    localStorage.setItem(
      "tokenExpiryTime",
      expirationDate.getTime().toString()
    );

    console.log("Token set successfully:", {
      token: `Bearer ${token}`,
      expires: expirationDate,
      cookieSet: !!Cookies.get("accessToken"),
    });
  } else {
    // Clear token from headers and cookies
    delete api.defaults.headers.common["Authorization"];
    Cookies.remove("accessToken", { path: "/" });
    localStorage.removeItem("tokenExpiryTime");
    console.log("Token cleared");
  }
};
